import { render } from "./ContextView.vue?vue&type=template&id=2017afd6&scoped=true"
import script from "./ContextView.vue?vue&type=script&lang=js"
export * from "./ContextView.vue?vue&type=script&lang=js"

import "./ContextView.vue?vue&type=style&index=0&id=2017afd6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2017afd6"]])

export default __exports__